export const rankingFilms = [
  {
    id: "rank-01",
    rank: 1,
    title: "寄生虫",
    original: "기생충",
    year: 2019,
    director: "奉俊昊",
    score: 9.3,
    genre: "社会现实",
    tags: ["阶级寓言", "黑色幽默", "家庭"],
    summary:
      "一户住在半地下室的家庭，用伪造学历与巧妙算计逐步渗透进上流豪宅。导演把“往上爬”这件事具象成楼梯与台阶的垂直空间，黑色幽默之下是一份冷静、锋利的阶层解剖。",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20film%20still%20of%20a%20steep%20outdoor%20staircase%20in%20a%20dense%20urban%20neighborhood%20at%20dusk%2C%20warm%20golden%20light%20raking%20across%20weathered%20walls%2C%20deep%20shadows%20and%20warm%20brown%20tones%2C%20quiet%20social%20tension%2C%20editorial%20photography%2C%20subtle%20film%20grain&width=760&height=960&seq=rank-01-parasite-house&orientation=portrait",
  },
  {
    id: "rank-02",
    rank: 2,
    title: "燃烧",
    original: "버닝",
    year: 2018,
    director: "李沧东",
    score: 8.7,
    genre: "人性与欲望",
    tags: ["悬疑", "阶层", "存在主义"],
    summary:
      "改编自村上春树短篇，三个年轻人在暧昧、猜忌与阶级落差之间彼此拉扯。温室疑云、黄昏里那段逆光独舞，都在提醒观众：有些真相并不会被真正说出口。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20lone%20figure%20standing%20by%20a%20vast%20field%20at%20golden%20sunset%2C%20distant%20greenhouse%20silhouette%2C%20hazy%20warm%20orange%20sky%2C%20atmospheric%20dust%2C%20melancholic%20mystery%20mood%2C%20warm%20amber%20color%20grading%2C%20soft%20film%20grain%2C%20editorial%20composition&width=760&height=960&seq=rank-02-burning-field&orientation=portrait",
  },
  {
    id: "rank-03",
    rank: 3,
    title: "老男孩",
    original: "올드보이",
    year: 2003,
    director: "朴赞郁",
    score: 8.6,
    genre: "悬疑与罪案",
    tags: ["复仇", "反转", "禁忌"],
    summary:
      "被莫名囚禁十五年后，男人开始寻找关押者并展开报复。暴烈的动作与层层反转之后，影片把“罪与罚”“亲缘与欲望”的边界推到观众面前，让人难以轻松离场。",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20film%20still%20of%20a%20dim%20corridor%20with%20a%20single%20warm%20light%2C%20a%20long%20shadow%20stretching%20across%20the%20floor%2C%20deep%20brown%20and%20amber%20tones%2C%20restrained%20dramatic%20tension%2C%20film%20noir%20mood%2C%20subtle%20grain%2C%20editorial%20photography&width=760&height=960&seq=rank-03-oldboy-corridor&orientation=portrait",
  },
  {
    id: "rank-04",
    rank: 4,
    title: "小姐",
    original: "아가씨",
    year: 2016,
    director: "朴赞郁",
    score: 8.6,
    genre: "人性与欲望",
    tags: ["欲望", "欺骗", "女性"],
    summary:
      "日据时期的深宅里，一场围绕遗产的骗局与一段悄然生长的感情彼此缠绕。精巧的分段叙事反复推翻观众对“到底谁在骗谁”的判断，视听华美而情绪克制。",
    image: "",
  },
  {
    id: "rank-05",
    rank: 5,
    title: "诗",
    original: "시",
    year: 2010,
    director: "李沧东",
    score: 8.5,
    genre: "社会现实",
    tags: ["老年", "记忆", "道德"],
    summary:
      "被阿尔茨海默症缠身的老人一边学着写诗，一边面对孙辈卷入的罪案。影片用诗意的凝视去追问一个难题：当现实让人不忍直视时，我们还能不能诚实地写下美好。",
    image: "",
  },
  {
    id: "rank-06",
    rank: 6,
    title: "密阳",
    original: "밀양",
    year: 2007,
    director: "李沧东",
    score: 8.4,
    genre: "家庭伦理",
    tags: ["信仰", "创伤", "宽恕"],
    summary:
      "丧夫的中年女子带着儿子回到亡夫的故乡重新开始，却在信仰的慰藉与崩塌之间反复摇摆。影片冷静地追问：宽恕这件事，究竟能不能由自己说了算。",
    image: "",
  },
  {
    id: "rank-07",
    rank: 7,
    title: "母亲",
    original: "마더",
    year: 2009,
    director: "奉俊昊",
    score: 8.5,
    genre: "悬疑与罪案",
    tags: ["母爱", "罪案", "执念"],
    summary:
      "为了洗清智障儿子的嫌疑，母亲独自踏上追查真相的路。当执念一点点盖过理性，母爱的边界也变得模糊，结尾那一幕让人久久无法平静。",
    image: "",
  },
  {
    id: "rank-08",
    rank: 8,
    title: "绿洲",
    original: "오아시스",
    year: 2002,
    director: "李沧东",
    score: 8.4,
    genre: "社会现实",
    tags: ["边缘人", "爱情", "偏见"],
    summary:
      "有前科的男人与患脑瘫的女子相恋，在旁人的偏见与误解里，两个被社会放在角落的人用笨拙而真诚的方式，守护着只属于彼此的一小片绿洲。",
    image: "",
  },
  {
    id: "rank-09",
    rank: 9,
    title: "82年生的金智英",
    original: "82년생 김지영",
    year: 2019,
    director: "金度英",
    score: 8.0,
    genre: "家庭伦理",
    tags: ["女性", "职场", "家庭"],
    summary:
      "从职场到育儿，从女儿到妻子与母亲，金智英在日复一日的规训中逐渐失语。影片没有激烈的控诉，只是安静地记录一个普通女性被生活一点点磨损的过程。",
    image: "",
  },
  {
    id: "rank-10",
    rank: 10,
    title: "家族的诞生",
    original: "가족의 탄생",
    year: 2006,
    director: "金泰勇",
    score: 8.1,
    genre: "家庭伦理",
    tags: ["亲情", "日常", "群像"],
    summary:
      "一顿饭、一间旧屋、几个各怀心事的家庭成员，导演把“家”既温暖又隔膜的两面拍得细腻真实。原来血缘只是起点，真正的家是彼此愿意留下的地方。",
    image: "",
  },
];

export const rankingGenres = [
  "全部",
  "社会现实",
  "人性与欲望",
  "家庭伦理",
  "悬疑与罪案",
];

export const themeCollections = [
  {
    key: "desire",
    label: "人性与欲望",
    intro:
      "这类作品把欲望当作解剖人性的切口：迷恋、占有、欺骗与自我欺骗层层嵌套，人物在道德边缘反复试探，观众也被迫一同掂量“想要”与“该不该”之间的距离。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20elegant%20old%20mansion%20interior%20at%20dusk%2C%20warm%20candlelight%20and%20deep%20shadows%2C%20intricate%20wallpaper%20and%20antique%20furniture%2C%20mysterious%20sensual%20mood%2C%20warm%20amber%20and%20brown%20color%20grading%2C%20soft%20film%20grain%2C%20editorial%20photography&width=800&height=600&seq=theme-desire-mansion&orientation=landscape",
    films: [
      {
        title: "小姐",
        year: 2016,
        director: "朴赞郁",
        note: "骗局与真情互为表里，三段式叙事把欲望写得既华丽又危险。",
      },
      {
        title: "燃烧",
        year: 2018,
        director: "李沧东",
        note: "暧昧与嫉妒在阶级落差中发酵，真相始终悬在半空。",
      },
      {
        title: "下女",
        year: 2010,
        director: "林常树",
        note: "豪宅里的权力与情欲交易，欲望最终反噬每一个参与者。",
      },
      {
        title: "情事",
        year: 1998,
        director: "李在容",
        note: "一段越界的感情，被拍成克制而绵长的日常消磨。",
      },
    ],
  },
  {
    key: "family",
    label: "家庭伦理",
    intro:
      "从餐桌到病房，家庭是韩国电影最常回望的现场。亲密关系里的爱、亏欠与控制彼此交织，所谓“为你好”有时也是伤害，这些作品擅长在琐碎日常里逼出情感的重量。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20modest%20family%20dining%20table%20at%20warm%20evening%20light%2C%20empty%20chairs%20and%20simple%20home%20objects%2C%20quiet%20melancholy%20atmosphere%2C%20warm%20golden%20and%20brown%20tones%2C%20soft%20film%20grain%2C%20editorial%20photography&width=800&height=600&seq=theme-family-table&orientation=landscape",
    films: [
      {
        title: "寄生虫",
        year: 2019,
        director: "奉俊昊",
        note: "两个家庭被一条隐形界线隔开，亲情也在其中被换算成筹码。",
      },
      {
        title: "母亲",
        year: 2009,
        director: "奉俊昊",
        note: "母爱的极致可以是守护，也可以是失控的执念。",
      },
      {
        title: "密阳",
        year: 2007,
        director: "李沧东",
        note: "丧子之痛与信仰困境交叠，宽恕被拆解成一道道难题。",
      },
      {
        title: "家族的诞生",
        year: 2006,
        director: "金泰勇",
        note: "几段松散的家庭关系，拼出“家”温暖又疏离的样子。",
      },
    ],
  },
  {
    key: "society",
    label: "社会现实",
    intro:
      "韩国电影常把镜头对准被忽视的人：失业者、边缘人、逐渐失语的女性与老人。它们不急着给出答案，而是把结构性的压力摊开，让观众自己去感受那份沉甸甸的现实。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20dense%20modern%20city%20skyline%20at%20dusk%20seen%20from%20a%20rooftop%2C%20warm%20hazy%20sunlight%20through%20haze%2C%20layered%20buildings%2C%20quiet%20social%20realism%20mood%2C%20warm%20amber%20and%20brown%20color%20grading%2C%20subtle%20film%20grain&width=800&height=600&seq=theme-society-city&orientation=landscape",
    films: [
      {
        title: "诗",
        year: 2010,
        director: "李沧东",
        note: "在丑陋的现实中练习寻找美，是一种近乎残酷的坚持。",
      },
      {
        title: "绿洲",
        year: 2002,
        director: "李沧东",
        note: "两个被社会定义的人相爱，偏见比疾病更让人窒息。",
      },
      {
        title: "82年生的金智英",
        year: 2019,
        director: "金度英",
        note: "一个普通女性的日常，记录着无处不在却难以指认的压力。",
      },
      {
        title: "薄荷糖",
        year: 1999,
        director: "李沧东",
        note: "用倒叙回望一个人的一生，遗憾被时代一点点放大。",
      },
    ],
  },
  {
    key: "suspense",
    label: "悬疑与罪案",
    intro:
      "罪案是外壳，人性才是内核。这一主题下的作品往往用一桩案件撬开人心，在追查真相的过程中，让“加害者”与“受害者”的身份不断滑动，考验观众的判断与共情。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20foggy%20mountain%20trail%20at%20dawn%20with%20a%20solitary%20walker%2C%20cold%20mist%20and%20warm%20stray%20light%2C%20mysterious%20quiet%20tension%2C%20muted%20warm%20color%20grading%2C%20soft%20film%20grain%2C%20editorial%20cinematography&width=800&height=600&seq=theme-suspense-mountain&orientation=landscape",
    films: [
      {
        title: "老男孩",
        year: 2003,
        director: "朴赞郁",
        note: "复仇的尽头是一个不愿被揭开的真相，反击越大，伤口越深。",
      },
      {
        title: "母亲",
        year: 2009,
        director: "奉俊昊",
        note: "为爱追凶的过程，也是一步步走近自我欺骗的过程。",
      },
      {
        title: "燃烧",
        year: 2018,
        director: "李沧东",
        note: "当线索只存在于怀疑之中，真相变成一场无法验证的拉扯。",
      },
      {
        title: "蝙蝠",
        year: 2009,
        director: "朴赞郁",
        note: "信仰、欲望与怪诞交织，善与恶在同一具身体里拉扯。",
      },
    ],
  },
];

export const newReleases = [
  {
    title: "分手的决心",
    original: "헤어질 결심",
    year: 2022,
    director: "朴赞郁",
    genre: "爱情 / 悬疑",
    summary:
      "一桩坠崖命案让刑警与嫌疑人之间产生微妙牵引。理智与情感在海雾与潮汐之间拉扯，导演把“看不清”本身拍成了一种浪漫。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20misty%20seaside%20cliff%20at%20blue%20hour%20with%20warm%20lantern%20glow%2C%20calm%20ocean%20and%20rocky%20coast%2C%20mysterious%20romantic%20mood%2C%20warm%20amber%20accents%20against%20cool%20shadows%2C%20soft%20film%20grain%2C%20editorial%20photography&width=900&height=620&seq=new-haejil-seacliff&orientation=landscape",
  },
  {
    title: "掮客",
    original: "브로커",
    year: 2022,
    director: "是枝裕和",
    genre: "剧情 / 家庭",
    summary:
      "一群因“弃养”而聚到一起的陌生人，带着婴儿踏上一段没有终点的旅程。血缘之外，他们重新定义了什么是“一起走着的人”。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20rainy%20rural%20road%20at%20dusk%20with%20warm%20headlight%20glow%2C%20wet%20asphalt%20reflections%20and%20roadside%20greenery%2C%20melancholic%20journey%20mood%2C%20warm%20brown%20and%20golden%20tones%2C%20soft%20film%20grain%2C%20editorial%20photography&width=900&height=620&seq=new-broker-roadtrip&orientation=landscape",
  },
  {
    title: "混凝土乌托邦",
    original: "콘크리트 유토피아",
    year: 2023,
    director: "严泰华",
    genre: "灾难 / 剧情",
    summary:
      "大地震后唯一幸存的一栋公寓成了孤岛，居民为资源与秩序制定新规则。当“我们”和“外人”被划清界限，人性开始经受极限测试。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20towering%20concrete%20apartment%20block%20at%20dusk%2C%20dramatic%20warm%20light%20through%20haze%2C%20brutalist%20architecture%20shadows%2C%20dystopian%20quiet%20tension%2C%20warm%20amber%20and%20gray%20brown%20color%20grading%2C%20film%20grain&width=900&height=620&seq=new-concrete-tower&orientation=landscape",
  },
  {
    title: "破墓",
    original: "파묘",
    year: 2024,
    director: "张在现",
    genre: "悬疑 / 惊悚",
    summary:
      "风水师、巫女与葬仪师受雇迁移一处异常墓穴，却在掘开旧土后释放出更深的禁忌。民俗与家族秘辛相互缠绕，寒意从画面渗到心里。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20ancient%20stone%20tomb%20entrance%20in%20a%20misty%20mountainside%20at%20dawn%2C%20warm%20ritual%20lantern%20glow%2C%20eerie%20mystery%20mood%2C%20deep%20brown%20earth%20tones%20with%20amber%20light%2C%20soft%20film%20grain%2C%20editorial%20photography&width=900&height=620&seq=new-pamyo-tomb&orientation=landscape",
  },
];

export const classicFilms = [
  {
    title: "薄荷糖",
    original: "박하사탕",
    year: 1999,
    director: "李沧东",
    genre: "剧情",
    summary:
      "用倒叙回到二十年前的一次集体出游，一颗薄荷糖串起一个人被时代与选择改写的一生。看完会久久想不起该责怪谁。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20empty%20train%20tracks%20curving%20through%20a%20hazy%20field%20at%20golden%20hour%2C%20nostalgic%20warm%20light%2C%20distant%20mountains%2C%20melancholic%20memory%20mood%2C%20warm%20amber%20and%20brown%20color%20grading%2C%20soft%20film%20grain&width=900&height=620&seq=classic-peppermint-rails&orientation=landscape",
  },
  {
    title: "春逝",
    original: "봄날은 간다",
    year: 2001,
    director: "许秦豪",
    genre: "爱情 / 剧情",
    summary:
      "录音师与电台 DJ 在乡间相处中萌生感情，又像季节一样无可挽回地淡去。安静、克制，把“失去”拍成了可以听见的声音。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20quiet%20riverside%20path%20lined%20with%20bare%20trees%20in%20late%20autumn%2C%20soft%20warm%20afternoon%20light%2C%20fallen%20leaves%2C%20tender%20melancholy%20mood%2C%20warm%20golden%20and%20brown%20tones%2C%20subtle%20film%20grain&width=900&height=620&seq=classic-spring-river&orientation=landscape",
  },
  {
    title: "下女",
    original: "하녀",
    year: 1960,
    director: "金基英",
    genre: "剧情 / 经典",
    summary:
      "韩国影史绕不开的经典：一名女佣进入中产家庭，欲望与阶级在密闭宅院里步步紧逼。黑白影像里的紧张感至今仍令人屏息。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20vintage%201960s%20Korean%20house%20interior%20with%20a%20staircase%20and%20warm%20window%20light%2C%20retro%20wallpaper%20and%20wooden%20furniture%2C%20restrained%20dramatic%20mood%2C%20warm%20amber%20and%20brown%20color%20grading%2C%20film%20grain&width=900&height=620&seq=classic-housemaid-house&orientation=landscape",
  },
  {
    title: "快乐到死",
    original: "해피엔드",
    year: 1999,
    director: "郑址宇",
    genre: "剧情 / 伦理",
    summary:
      "一个失业在家的丈夫、一个重返职场的妻子与一段婚外情，把中产的体面一点点拆开。结尾的“快乐”二字，冷得让人心惊。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20dim%20apartment%20living%20room%20at%20night%20with%20warm%20lamp%20light%20and%20long%20shadows%2C%20minimalist%20modern%20furniture%2C%20quiet%20domestic%20tension%2C%20warm%20brown%20and%20amber%20tones%2C%20subtle%20film%20grain&width=900&height=620&seq=classic-happyend-rooms&orientation=landscape",
  },
];

export const directors = [
  {
    name: "奉俊昊",
    initial: "奉",
    style: "类型片外壳下的社会寓言",
    desc: "擅长用悬疑、怪兽或灾难的类型外壳包裹阶层观察，节奏精准，冷幽默与残酷感并存。",
    works: "《寄生虫》《母亲》《雪国列车》",
  },
  {
    name: "朴赞郁",
    initial: "朴",
    style: "华丽视听与复仇伦理",
    desc: "构图与配乐极尽考究，常以复仇、欲望与禁忌为题，把暴力拍得优雅又令人不安。",
    works: "《老男孩》《小姐》《分手的决心》",
  },
  {
    name: "李沧东",
    initial: "李",
    style: "诗意现实主义",
    desc: "关注边缘人与被时代碾过的人，叙事克制留白，于微小日常里逼问信仰、宽恕与意义。",
    works: "《薄荷糖》《诗》《燃烧》",
  },
  {
    name: "金基德",
    initial: "金",
    style: "极简与欲望隐喻",
    desc: "台词极少、场景极简，用身体与沉默承载暴力、欲望与救赎，风格强烈而争议并存。",
    works: "《空房间》《春夏秋冬又一春》",
  },
  {
    name: "洪常秀",
    initial: "洪",
    style: "日常对话与情感留白",
    desc: "反复处理相遇、喝酒与暧昧，用轻盈的对话与结构变化，捕捉关系里说不清的那部分。",
    works: "《这时对那时错》《逃走的女人》",
  },
];

export const ratingLevels = [
  {
    level: "全员观览",
    color: "secondary",
    desc: "主题温和，情绪克制，适合与家人一同观看，属于入门级的剧情与家庭题材。",
  },
  {
    level: "12 岁以上",
    color: "primary",
    desc: "含有一定现实议题与情绪冲击，建议具备基础理解力的观众，便于消化片中讨论。",
  },
  {
    level: "15 岁以上",
    color: "primary",
    desc: "涉及暴力、罪案或成人关系的描写，画面与主题较重，建议成熟的观影心态。",
  },
  {
    level: "青少年观览不可",
    color: "accent",
    desc: "部分作品在韩国属于限制级，包含强烈的暴力或情欲表达，需年满成年后观看。",
  },
];

export const watchTips = [
  {
    icon: "ri-focus-3-line",
    title: "先看主题，再看评分",
    desc: "分数只能说明完成度，题材才决定你会不会被触动。先挑对胃口的方向，再让评分来做筛选。",
  },
  {
    icon: "ri-emotion-line",
    title: "预留情绪缓冲",
    desc: "这类作品常常后劲很足，看完不妨留一段时间散步或记录感受，让情绪自然落地。",
  },
  {
    icon: "ri-group-line",
    title: "结伴讨论更佳",
    desc: "开放式结局最适合和朋友一起聊，交换彼此的理解，往往能看到自己忽略的细节。",
  },
  {
    icon: "ri-shield-check-line",
    title: "留意分级提示",
    desc: "涉及罪案与成人的内容并不适合所有人，请结合自身状态与年龄选择，量力而看。",
  },
];

export const faqs = [
  {
    q: "这份片单里的“伦理电影”具体指哪一类作品？",
    a: "这里的“伦理”侧重道德与人性层面的探讨，包括家庭关系、欲望与克制、罪与罚、社会身份等主题。入选作品不一定有激烈的情节，它们更关心人物在道德困境中的选择，以及选择带来的后果。",
  },
  {
    q: "排行榜的评分是什么标准？",
    a: "评分是编辑部综合叙事完成度、表演、影像风格与议题深度给出的观感参考，并非单一平台的评分。它更像一份“值不值得花两小时”的判断，建议结合每部作品下方的介绍按主题来挑。",
  },
  {
    q: "这么多片子，怎样快速找到适合我的？",
    a: "可以用页面里的题材筛选与关键词搜索快速缩小范围，也可以点开“主题合集”按当下心情选择——想看人性的复杂就挑“人性与欲望”，想被现实触动就挑“社会现实”。",
  },
  {
    q: "这些影片在哪里可以观看？",
    a: "本站只做片单整理与介绍，不提供播放。影片可以通过正规流媒体平台、影展放映或蓝光收藏等渠道欣赏；不同地区的片源与上映情况会有差异，请以当地可获取的正版渠道为准。",
  },
  {
    q: "片单会持续更新吗？",
    a: "会。我们会把新近上映、口碑不错的作品补充进“最新片单”，同时保留经典高分合集作为长期参考。如果你有特别想看的主题，也可以据此调整后续整理方向。",
  },
  {
    q: "看完之后情绪不太好，怎么调整？",
    a: "这类作品本就想留下些什么，若感到沉重，可以先换一部轻松的题材过渡，或把感受写下来。看片是为生活服务，不必强迫自己一次消化所有情绪。",
  },
];